import React from 'react';
import {
  Grid,
  Header,
} from 'semantic-ui-react';
import PropTypes from 'prop-types';

const steps = [
  {
    icon: 'verification',
    title: 'Verification',
    description: 'Upload form signed by purchaser',
  },
  {
    icon: 'ic_small',
    title: 'Photo of IC',
    description: 'Upload photo of IC front and back',
  },
  {
    icon: 'income',
    title: 'Income',
    description: 'Input either basic or detailed income',
  },
  {
    icon: 'credit_check',
    title: 'Generate Score',
    description: 'CTOS & DSR score',
  },
];

const CreditCheckSplash = ({ actionNode }) => (
  <Grid stackable doubling style={{ marginTop: '1em' }} textAlign="center">
    <Grid.Row columns={4}>
      {
        steps.map((step, idx) => (
          <Grid.Column key={idx}>
            <Header as="h3" icon>
              <i className="blue circular inverted icon">
                <img src={`/assets/images/icons/${step.icon}.svg`} alt="" />
              </i>
              {idx + 1}. {step.title}
              <Header.Subheader>
                {step.description}
              </Header.Subheader>
            </Header>
            {
              idx === 0 ? (
                <p><strong>
                  <a
                    href="https://mhub.my/consent/credit_check/"
                    style={{ color: '#57B4CA' }}
                  >Download Form</a>
                </strong></p>
              ) : null
            }
          </Grid.Column>
        ))
      }
    </Grid.Row>
    {actionNode}
  </Grid>
);

CreditCheckSplash.propTypes = {
  actionNode: PropTypes.node,
};

export default CreditCheckSplash;



// WEBPACK FOOTER //
// ./src/components/CreditCheckSplash.jsx